import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, useCallback, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import generateId from '../../utils/generateId';
import Select from '../Select/Select';
import { PaginationContext } from './PaginationContext';
const paginatorWidth = 130;
const condensedPageNumbersStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  display: flex;
  align-items: center;
  margin-left: ${theme.spacing.base};
  margin-right: ${theme.spacing.base};
  width: ${styleUtils.rem(paginatorWidth)};
`;
const CondensedPageNumbers = ({ onPageClick, }) => {
    const { currentPageNumber, totalPages, } = useContext(PaginationContext);
    const handleChange = useCallback((event) => {
        const selectedPage = Number(event.target.value);
        if (onPageClick) {
            onPageClick(selectedPage);
        }
    }, [
        onPageClick,
    ]);
    const pageOptions = useMemo(() => Array(totalPages).fill(null).map((_item, index) => ({
        text: `${index + 1} of ${totalPages}`,
        value: index + 1,
    })), [
        totalPages,
    ]);
    return (_jsx("div", Object.assign({ css: condensedPageNumbersStyles }, { children: _jsx(Select, { label: "Page", name: `page-select-${generateId()}`, onChange: handleChange, options: pageOptions, size: 'medium', value: currentPageNumber }) })));
};
const MemoizedCondensedPageNumbers = memo(CondensedPageNumbers);
export { MemoizedCondensedPageNumbers as CondensedPageNumbers };
